<template>
    <div class="container">
        <div class="fixed-cards">
            <!-- 前仓详情详情的表单 -->
            <el-card shadow="hover" class="card">
                <div slot="header" class="clearfix">
                    <span>前仓详情信息:</span>
                </div>
                <div class="card-content">
                    <el-row>
                        <el-col :span="24"><strong>关联店铺名称:</strong> {{ info.shopName }}</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6"><strong>前仓名称:</strong> {{ info.warehouseName }}</el-col>
                        <el-col :span="6"><strong>前仓手机号:</strong> {{ info.warehouseMobile }}</el-col>
                        <el-col :span="12"><strong>前仓地址:</strong> {{ info.address }}</el-col>
                    </el-row>
                </div>
            </el-card>
        </div>
        <div class="fixed-cards">
            <el-card shadow="hover" class="card">
                <basic-container>
                    <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page"
                        ref="crud" @search-change="searchChange" @refresh-change="refreshChange(page)"
                        @selection-change="handleSelectionChange" @size-change="pageSizeChange"
                        @row-update="handleUpdate" @current-change="pageChange">
                        <template slot-scope="scope" slot="menuLeft">
                            <el-button size="mini" type="primary" @click="handleAdd" icon="el-icon-plus">
                                入库
                            </el-button>
                            <!-- 吊顶入库 -->
                            <el-button size="mini" type="primary" @click="handleAddCeiling" icon="el-icon-plus">
                                吊顶入库
                            </el-button>
                            <el-button size="mini" type="success" @click="handleView()" icon="el-icon-view">
                                按产品查看库存
                            </el-button>
                        </template>
                        <template slot-scope="scope" slot="menu">
                            <el-button size="mini" type="danger" @click="handleDel(scope.row)" icon="el-icon-delete">
                                删除
                            </el-button>
                        </template>
                        <template slot-scope="scope" slot="picUrl">
                            <viewer :images="formmaterImage(scope.row.picUrl)">
                                <img v-for="src in formmaterImage(scope.row.picUrl)" :src="src" :key="src" width="20" />
                            </viewer>
                        </template>
                    </avue-crud>
                </basic-container>
            </el-card>
        </div>
        <!-- 新增弹窗表单 -->
        <el-dialog title="入库" :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false">
            <el-form :model="form">
                <el-table :data="form.items" border style="width: 100%; margin-top: 20px">
                    <el-table-column prop="goodsId" label="产品" min-width="150">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.goodsId" placeholder="请选择产品" required value-key="id"
                                @change="updateSelectedGoods">
                                <el-option v-for="goods in goodsList" :key="goods.id" :label="goods.name"
                                    :value="goods.id"
                                    :disabled="isGoodsSelected(goods.id, scope.row.goodsId)"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="num" label="数量" min-width="150">
                        <template slot-scope="scope">
                            <el-input type="number" v-model="scope.row.num" placeholder="请输入数量" min="1"
                                clearable></el-input>
                        </template>
                    </el-table-column>
                    <!-- 删除产品 -->
                    <el-table-column align="center" label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button type="danger" icon="el-icon-close" size="small"
                                @click="delFormItem(scope.$index)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 动态添加表单项按钮 -->
                <el-button type="text" icon="el-icon-plus" @click="addFormItem">添加产品</el-button>
                <!-- 上传凭证 -->
                <el-form-item label="上传凭证:">
                    <ImageUpload action="#" :multiple="true" :limit="5" @uploaded="handleUploaded"
                        :listTypeMode="listTypeMode" :uploaded-images="picUrl" />
                </el-form-item>
            </el-form>
            <!-- 提交表单按钮 -->
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelForm">取 消</el-button>
                <el-button type="primary" @click="submitForm">提交</el-button>
            </div>
        </el-dialog>
        <!-- 新增吊顶弹窗表单 -->
        <el-dialog title="新增吊顶入库" :visible.sync="dialogVisibleCeiling" width="50%" :close-on-click-modal="false">
            <el-form :model="ceilingForm" ref="ceilingForm" :rules="ceilingRules">
                <el-form-item label="选择产品" prop="items">
                    <ceiling-product-selector v-model="ceilingForm.items" :goods-list="ceilingGoodsList" />
                </el-form-item>
                <!-- 上传凭证 -->
                <el-form-item label="上传凭证:">
                    <ImageUpload action="#" :multiple="true" :limit="5" @uploaded="handleCeilingUploaded"
                        :listTypeMode="listTypeMode" :uploaded-images="ceilingPicUrl" />
                </el-form-item>
            </el-form>
            <!-- 提交表单按钮 -->
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelCeilingForm" icon="el-icon-close">取 消</el-button>
                <el-button type="primary" @click="submitCeilingForm" icon="el-icon-check">提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    getWarehouseDetail,
    getWarehouseEntryDetailList,
    increaseGoods,
    delDetailGoods,
} from "@/api/salesCloud/warehouse";
import { warehouseGoodsDetailOption } from "@/const/salesCloud/warehouseGoodsDetailOption";
import { findPureWaterGoodsByRootDepartIds, findPureWaterGoodsByRootDepartId } from "@/api/salesCloud/goodsQr";
import ImageUpload from "@/components/imageUpload/ImageUpload";
import ceilingProductSelector from "./components/ceiling-product-selectator.vue";
export default {
    name: "warehouseDetails",
    components: {
        ImageUpload,
        ceilingProductSelector,
    },
    data() {
        return {
            info: {},
            tableOption: warehouseGoodsDetailOption, //表格设置属性
            goodsList: [], //产品列表
            goods: {}, //产品
            picUrl: "", //上传凭证
            listTypeMode: "picture-card",
            tableData: [], //表格的数据
            tablePage: 1,
            tableLoading: false,
            loading: false,
            ids: "",
            point: {},
            warehouseId: "",
            selectedGoods: [], // 存储已选产品的数组
            dialogVisible: false,
            dialogVisibleCeiling: false,
            page: {
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 10, //每页显示多少条
            },
            form: {
                items: [
                    {
                        num: "",
                        warehouseId: this.$route.query.id,
                        goodsId: "",
                        type: "INCREASE",
                    },
                ],
            },
            ceilingForm: {
                items: [{
                    goodsId: [],
                    num: 1
                }],
                warehouseId: this.$route.query.id,
                type: "INCREASE"
            },
            ceilingPicUrl: [],
            ceilingGoodsList: [],
            ceilingRules: {
                items: [
                    { required: true, message: '请至少选择一个商品', trigger: 'change' }
                ],
                picUrl: [
                    { required: true, message: '请上传凭证', trigger: 'change' }
                ]
            },
        };
    },
    created() {
        // 使用前仓ID获取前仓信息
        getWarehouseDetail(this.$route.query.id).then((res) => {
            this.info = JSON.parse(res.data);
        });
        this.findPureWaterGoodsByRootDepartIds();
        this.getWarehouseEntryDetailList();
        this.loadCeilingGoodsList();
    },
    methods: {
        handleUploaded(url) {
            this.picUrl = url;
            this.tableLoading = false;
        },
        findPureWaterGoodsByRootDepartIds() {
            findPureWaterGoodsByRootDepartIds().then((res) => {
                let data = JSON.parse(res.data);
                if (data == null) {
                    this.goodsList = [];
                } else {
                    this.goodsList = data;
                }
            });
        },
        // 加载级联商品数据，并初始化 selectedGoods
        loadCeilingGoodsList() {
            const type = "HANG_CEILING";
            findPureWaterGoodsByRootDepartId(type).then(res => {
                if (res.code === "200") {
                    const raw = JSON.parse(res.data);
                    // 将数据转换为级联选择器需要的格式
                    this.ceilingGoodsList = raw.map(item => ({
                        value: item.id,
                        label: item.name,
                        children: item.filters ? item.filters.map(f => ({
                            value: f.id,
                            label: f.value
                        })) : []
                    }));
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        handleAdd() {
            this.form.items = [
                {
                    num: "",
                    warehouseId: this.$route.query.id,
                    goodsId: "",
                    type: "INCREASE",
                },
            ];
            this.picUrl = "";
            this.dialogVisible = true;
        },
        handleAddCeiling() {
            this.ceilingForm = {
                items: [{
                    goodsId: [],
                    num: 1
                }],
                warehouseId: this.$route.query.id,
                type: "INCREASE"
            };
            this.ceilingPicUrl = [];
            this.dialogVisibleCeiling = true;
        },
        formmaterImage(row) {
            let str = new Array();
            JSON.stringify(row);
            if (row != null) {
                let picArray = row.split(",");
                for (let i = 0; i < picArray.length; i++) {
                    str.push(picArray[i]);
                }
            }
            return str;
        },
        pageSizeChange(pageSize) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = this.page.currentPage;
            params.size = pageSize;
            params.warehouseId = this.$route.query.id;
            this.downloadData = params;
            getWarehouseEntryDetailList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: pageSize,
                };
                this.tableLoading = false;
            });
        },
        pageChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page;
            params.size = this.page.pageSize;
            this.downloadData = params;
            params.warehouseId = this.$route.query.id;
            getWarehouseEntryDetailList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page,
                    pageSize: this.page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        searchChange(params) {
            this.tableLoading = true;
            params.page = this.page.currentPage;
            params.size = this.page.pageSize;
            params.warehouseId = this.$route.query.id;
            getWarehouseEntryDetailList(params).then((res) => {
                if (res.code != 500) {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: params.page,
                        pageSize: params.size,
                    };
                    this.tableLoading = false;
                } else {
                    this.tableLoading = false;
                    this.tableData = [];
                }
            });
        },
        refreshChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page.currentPage;
            params.size = page.pageSize;
            this.downloadData = params;
            params.warehouseId = this.$route.query.id;
            getWarehouseEntryDetailList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page.currentPage,
                    pageSize: page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        AddIncrease(id) {
            this.dialogVisibleIncrease = true;
            this.formIncrease.items[0].goodsId = id;
        },
        // 更新已选产品的数组
        updateSelectedGoods() {
            this.selectedGoods = this.form.items
                .map((item) => item.goodsId)
                .filter(Boolean);
        },
        // 判断产品是否已被选择，排除当前行的产品
        isGoodsSelected(goodsId, currentGoodsId) {
            return this.selectedGoods.includes(goodsId) && goodsId !== currentGoodsId;
        },
        addFormItem() {
            if (
                this.selectedGoods.length === this.goodsList.length ||
                this.form.items.length >= this.goodsList.length
            ) {
                this.$message({
                    showClose: true,
                    message: "不能再添加产品了",
                    type: "warning",
                });
                return;
            }
            this.form.items.push({
                num: "",
                warehouseId: this.$route.query.id,
                goodsId: "",
                type: "INCREASE",
            });
        },
        delFormItem(index) {
            this.form.items.splice(index, 1);
            this.updateSelectedGoods();
        },
        cancelForm() {
            this.dialogVisible = false;
            this.picUrl = "";
            this.form.items = [
                {
                    num: "",
                    warehouseId: this.$route.query.id,
                    goodsId: "",
                    type: "INCREASE",
                },
            ];
        },
        submitForm() {
            let params = this.form.items;
            // 产品校验
            let goodsIds = params.map((item) => item.goodsId);
            if (goodsIds.includes("")) {
                this.$message({
                    showClose: true,
                    message: "请选择商品",
                    type: "warning",
                });
                return;
            }
            // 将图片地址拼接到params每一项产品中
            params.forEach((item) => {
                item.picUrl = this.picUrl.map((url) => url.url).join(",")?item.picUrl = this.picUrl.map((url) => url.url).join(","):"";
            });
            increaseGoods(params).then((res) => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "入库成功",
                        type: "success",
                    });
                    // 重置表单
                    this.form.items = [
                        {
                            num: "",
                            warehouseId: this.$route.query.id,
                            goodsId: "",
                            type: "INCREASE",
                        },
                    ];
                    this.picUrl = "";
                    this.dialogVisible = false;
                    this.getWarehouseEntryDetailList();
                } else {
                    setTimeout(() => {
                        this.$message({
                            showClose: true,
                            message: res.message ? res.message : "入库失败,请重试",
                            type: "error",
                        });
                    }, 1000);
                }
            });
        },
        handleCeilingGoodsChange(row) {
            // 处理商品选择变化
            // 确保商品ID是有效的
            if (!row.goodsId) {
                this.$message({
                    showClose: true,
                    message: "请选择有效的商品",
                    type: "warning"
                });
            }
        },
        handleCeilingNumChange(row) {
            // 处理数量变化
            // 确保数量是有效的
            if (!row.num || row.num < 1) {
                row.num = 1;
            }
        },
        handleCeilingUploaded(url) {
            this.ceilingPicUrl = url;
        },
        cancelCeilingForm() {
            this.dialogVisibleCeiling = false;
            this.ceilingPicUrl = [];
            this.ceilingForm = {
                items: [{
                    goodsId: [],
                    num: 1
                }],
                warehouseId: this.$route.query.id,
                type: "INCREASE"
            };
            if (this.$refs.ceilingForm) {
                this.$refs.ceilingForm.resetFields();
            }
        },
        submitCeilingForm() {
            this.$refs.ceilingForm.validate(valid => {
                if (!valid) {
                    return;
                }
                if (!this.ceilingForm.items || this.ceilingForm.items.length === 0) {
                    this.$message({
                        showClose: true,
                        message: "请至少选择一个商品",
                        type: "warning"
                    });
                    return;
                }
                // 验证所有商品是否都已选择
                const invalidItems = this.ceilingForm.items.filter(item => !item.goodsId || item.goodsId.length === 0);
                if (invalidItems.length > 0) {
                    this.$message({
                        showClose: true,
                        message: "请选择所有商品",
                        type: "warning"
                    });
                    return;
                }
                // 验证数量
                const invalidNums = this.ceilingForm.items.filter(item => !item.num || item.num < 1);
                if (invalidNums.length > 0) {
                    this.$message({
                        showClose: true,
                        message: "请确保所有商品数量有效",
                        type: "warning"
                    });
                    return;
                }
                // 准备提交数据
                let params = this.ceilingForm.items.map(item => ({
                    goodsId: Array.isArray(item.goodsId) ? item.goodsId[item.goodsId.length - 1] : item.goodsId,
                    num: item.num,
                    warehouseId: this.ceilingForm.warehouseId,
                    type: this.ceilingForm.type,
                    picUrl: this.ceilingPicUrl ? this.ceilingPicUrl.map(url => url.url).join(",") : ""
                }));
                increaseGoods(params).then((res) => {
                    if (res.code == "200") {
                        this.$message({
                            showClose: true,
                            message: "吊顶入库成功",
                            type: "success"
                        });
                        this.cancelCeilingForm();
                        this.getWarehouseEntryDetailList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message ? res.message : "入库失败,请重试",
                            type: "error"
                        });
                    }
                });
            });
        },
        handleEdit(row, index) {
            this.$refs.crud.rowEdit(row, index);
            this.department = {
                id: row.shopId,
                shopName: row.shopName,
            };
            this.point = {
                address: row.address,
                location: {
                    lng: row.longitude,
                    lat: row.latitude,
                },
            };
        },
        handleUpdate(form, index, done, loading) {
            let params = {
                ...form,
                id: form.id,
                shopId: this.department.id,
                warehouseGoodsName: form.warehouseGoodsName,
                warehouseGoodsMobile: form.warehouseGoodsMobile,
                address: this.point.address,
                longitude: this.point.location.lng,
                latitude: this.point.location.lat,
            };
            const isEdit = true;
            increaseGoods(params, isEdit).then((res) => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "修改成功",
                        type: "success",
                    });
                    done();
                    this.getWarehouseEntryDetailList();
                } else {
                    setTimeout(() => {
                        this.$message({
                            showClose: true,
                            message: res.message ? res.message : "编辑失败,请重试",
                            type: "error",
                        });
                        loading();
                    }, 1000);
                }
            });
        },
        handleView() {
            //查看库存
            this.$router.push({
                path: "/salesCloud/warehouse/detailEntry",
                query: {
                    id: this.$route.query.id,
                },
            });
        },
        /**
         * @title 当前选中的数据
         * @param val 选中的值
         *
         **/
        handleSelectionChange(val) {
            let ids = val.map((item) => {
                return item.id;
            });
            this.ids = ids.join(",");
        },
        /**
         * @title 数据删除
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         *
         **/
        handleDel(row) {
            let ids = "";
            ids = this.ids;
            if (row) {
                ids = row.id;
                this.$confirm(`您确定删除该条数据吗？`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        delDetailGoods(ids)
                            .then((res) => {
                                if (res.code == "200") {
                                    this.$message({
                                        showClose: true,
                                        message: "成功删除",
                                        type: "success",
                                    });
                                    this.getWarehouseEntryDetailList();
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: res.message ? res.message : "删除失败,请重试",
                                        type: "error",
                                    });
                                }
                            })
                            .catch((error) => {
                                this.loading = false;
                                this.$message({
                                    showClose: true,
                                    message: error,
                                    type: "error",
                                });
                            });
                    })
                    .catch(() => { });
            } else {
                if (!ids) {
                    this.$message({
                        showClose: true,
                        message: "未选中任何数据",
                        type: "error",
                    });
                    return;
                }
                let length = ids.split(",").length;
                this.$confirm(`共选中${length}条数据吗，您确定批量删除吗？`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        delDetailGoods(ids)
                            .then((res) => {
                                if (res.code == "200") {
                                    this.$message({
                                        showClose: true,
                                        message: "成功",
                                        type: "success",
                                    });
                                    this.getWarehouseEntryDetailList();
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: res.message,
                                        type: "error",
                                    });
                                }
                            })
                            .catch((error) => {
                                this.loading = false;
                                this.$message({
                                    showClose: true,
                                    message: error,
                                    type: "error",
                                });
                            });
                    })
                    .catch(() => { });
            }
        },
        getWarehouseEntryDetailList() {
            this.tableLoading = true;
            let params = {
                page: this.page.currentPage,
                size: this.page.pageSize,
                warehouseId: this.$route.query.id,
            };
            this.downloadData = params;
            getWarehouseEntryDetailList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        goBack() {
            this.$router.go(-1);
        },
    },
};
</script>
<style scoped>
.container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 10px;
    min-height: 80%;
    box-sizing: border-box;
    font-family: fangsong;
    font-size: large;
}
.fixed-cards {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}
.card {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.card-content {
    padding: 20px;
}
/* 确保表格的字体与其他部分一致 */
.el-table {
    font-family: fangsong;
    font-weight: bold;
    font-size: large;
}
.el-table th,
.el-table td {
    font-family: fangsong;
    font-size: large;
}
.el-table th {
    font-family: fangsong;
    font-size: large;
}
</style>
